import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import highestLowestRollovers from "./highLowRollover";
import drivingMarketParamsReducer from "../drivingMarketParams";
export default combineReducers({
    reducersData: highestLowestRollovers,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
